module.exports = __webpack_public_path__ + "static/MGA-fe1673bb1421f15274e61af62b8f3d42.jpg";